import { useTranslation } from 'react-i18next';

import { addAuditFilters, applyAuditFilterChange } from '@/domain/auditLog';

import FilterTextField from '../../FilterTextField';
import FilterMenu from '../FilterMenu';
import type { AuditFilterBindings } from '../filterBindings';
import { methodSections } from '../filterOptions';

import FilterGroup from './FilterGroup';
import PanelField from './PanelField';

interface RequestFiltersProps {
    bindings: AuditFilterBindings;
}

export default function RequestFilters({ bindings }: RequestFiltersProps) {
    const { filters, onChange, onType } = bindings;
    const { t } = useTranslation();

    return (
        <FilterGroup legend={t('auditLog.filters.group.request')}>
            <FilterTextField
                field="ip"
                label={t('auditLog.filters.ip')}
                filters={filters}
                onType={onType}
            />
            <FilterTextField
                field="requestId"
                label={t('auditLog.filters.requestId')}
                filters={filters}
                onType={onType}
            />
            <PanelField label={t('auditLog.filters.method')}>
                {(labelId) => (
                    <FilterMenu
                        label={t('auditLog.filters.method')}
                        labelledBy={labelId}
                        options={methodSections()}
                        selected={filters.method}
                        onChange={(method) =>
                            onChange(applyAuditFilterChange(filters, addAuditFilters({ method })))
                        }
                    />
                )}
            </PanelField>
            <FilterTextField
                field="route"
                label={t('auditLog.filters.route')}
                filters={filters}
                onType={onType}
            />
            <FilterTextField
                field="userAgent"
                label={t('auditLog.filters.userAgent')}
                placeholder={t('auditLog.filters.containsPlaceholder')}
                filters={filters}
                onType={onType}
            />
        </FilterGroup>
    );
}
